import React from 'react';
import { Row, Col } from 'antd';
import '../../../assets/gantt/dhtmlxgantt.css';
import '../css/index.css';

// Constantes estáticas
const HEIGHT_GANTT = 'calc(100vh - 214px)';
const CONTAINER_STYLE = { width: '100%', height: '100%' };

/**
 * Componente principal del cronograma que renderiza el contenedor del Gantt
 */
const ScheduleView = () => (
  <Row>
    <Col span={24}>
      <div className="gantt-container" style={{ height: HEIGHT_GANTT }}>
        <div
          className="new-gantt-chart"
          id="scheduleContainer"
          style={CONTAINER_STYLE}
        />
      </div>
    </Col>
  </Row>
);

ScheduleView.displayName = 'ScheduleView';

export default React.memo(ScheduleView);
